import React from 'react';
import Button from '../../Shared/UI/Button/components/Button';
import { useGroupActions } from './GroupContext';
import styles from './CreateGroupsButton.module.scss';

const CreateGroupsButton = ({ authenticatedUser }) => {
  const { openGroupModal } = useGroupActions();

  if (!authenticatedUser?.canCreateGroups) {
    return null;
  }

  return (
    <div className={styles.createGroupsContainer}>
      <Button
        variant="primary"
        onClick={(e) => {
          e.preventDefault();
          openGroupModal();
        }}
      >
        Create A Group
      </Button>
    </div>
  );
};

export default CreateGroupsButton;
